import React, { PureComponent } from 'react'
import { FormControl, InputLabel, MenuItem, Select, Input } from '@material-ui/core'

import { isValidAlphaNumeric, isValidString } from '../../utils/string'

import ForwardRefHOC from '../../containers/HOC/ForwardRefHOC'
import ModalDialog from '../common/ModalDialog'

class AddPosTerminalModal extends PureComponent {
  state = {
    name: '',
    serialNumber: '',
    registerId: '',
    authKey: '',
  }

  addPosTerminal = () => {
    const { name, serialNumber, registerId, authKey } = this.state

    const { processors } = this.props

    if (!isValidString(name)) {
      this.props.onError('Please provide a valid POS name')
      return
    }

    if (!isValidString(serialNumber)) {
      this.props.onError('Please provide a valid POS serialNumber')
      return
    }

    if (
      !isValidAlphaNumeric(serialNumber) ||
      !isValidAlphaNumeric(registerId) ||
      !isValidAlphaNumeric(authKey)
    ) {
      console.log(!isValidAlphaNumeric(serialNumber))
      this.props.onError('Special characters not allowed')
      return
    }

    if (!isValidString(registerId)) {
      this.props.onError('Please provide a valid POS registerId')
      return
    }

    if (!isValidString(authKey)) {
      this.props.onError('Please provide a valid POS authKey')
      return
    }

    const processorValues = []

    processors.forEach((process) => processorValues.push(process.value))

    this.props.addPosTerminal({
      name,
      serialNumber,
      registerId,
      authKey,
      online: false,
      enabled: true,
      processors: processorValues,
    })
  }

  onClose = () => {
    this.setState({
      name: '',
      serialNumber: '',
      registerId: '',
      authKey: '',
    })
  }

  onOpen = (type) => {
    this.setState({
      name: '',
      serialNumber: '',
      registerId: '',
      authKey: '',
    })
  }

  onNewPosTerminalChange = (key) => (e) => {
    this.setState({
      [key]: e.target.value,
    })
  }

  render() {
    const { forwardedRef } = this.props

    const { name, serialNumber, registerId, authKey } = this.state

    return (
      <ModalDialog
        title={'Add POS Terminal'}
        ref={forwardedRef}
        onConfirm={this.addPosTerminal}
        onClose={this.onClose}
        onOpen={this.onOpen}
      >
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Name *</InputLabel>
          <Input value={name} onChange={this.onNewPosTerminalChange('name')} fullWidth />
        </FormControl>
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Serial Number *</InputLabel>
          <Input
            value={serialNumber}
            onChange={this.onNewPosTerminalChange('serialNumber')}
            fullWidth
          />
        </FormControl>
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Register ID *</InputLabel>
          <Input
            value={registerId}
            onChange={this.onNewPosTerminalChange('registerId')}
            fullWidth
          />
        </FormControl>
        <FormControl fullWidth className="margin-bottom-small">
          <InputLabel>Auth Key *</InputLabel>
          <Input value={authKey} onChange={this.onNewPosTerminalChange('authKey')} fullWidth />
        </FormControl>
      </ModalDialog>
    )
  }
}

export default ForwardRefHOC(AddPosTerminalModal)



// WEBPACK FOOTER //
// ./src/components/Modal/AddPosTerminalModal.js